import { render, staticRenderFns } from "./RequestJoinProject.vue?vue&type=template&id=83afa9b0&scoped=true"
import script from "./RequestJoinProject.vue?vue&type=script&lang=js"
export * from "./RequestJoinProject.vue?vue&type=script&lang=js"
import style0 from "./RequestJoinProject.vue?vue&type=style&index=0&id=83afa9b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83afa9b0",
  null
  
)

export default component.exports